export const API_STATES = {
    default: {
        data: undefined,
        error: undefined,
        loaded: undefined,
        isLoading: undefined,
    },
    getStates: (setState) => ({
        pending: () =>
            setState({
                data: undefined,
                error: undefined,
                loaded: undefined,
                isLoading: true,
            }),
        success: (data) => {
            setState({
                data,
                error: null,
                loaded: true,
                isLoading: false,
            });

            return data;
        },
        error: (error) => {
            setState({
                data: undefined,
                error: error.message,
                loaded: false,
                isLoading: false,
            });

            return error;
        },
    }),
};

// Recursive variant converting from JSON to x-www-form-urlencoded with escaping names and values
export const JSONToFormURLEncoded = (element, key = "", list = []) => {
    if (typeof element == "object") {
        for (const idx in element) {
            JSONToFormURLEncoded(element[idx], key ? key + "[" + idx + "]" : idx, list);
        }
    } else {
        list.push(key + "=" + encodeURIComponent(element));
    }
    return list.join("&");
};
